import axios from 'axios';
export const WORK_API = `${process.env.REACT_APP_BACKEND_URL}/api/field/work`;
export const downloadTicket = async (ticket) => {
  const response = await axios.get(`${WORK_API}/tickets/${ticket.id}/pdf`, { responseType: 'blob' });
  const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
  const link = document.createElement('a'); link.href = url;
  link.download = `FieldTicket-${ticket.work_date}-${ticket.id.slice(0, 8)}.pdf`;
  document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
export const isFieldReviewer = (user) => ['management', 'field_management'].includes(user?.role);